// extracted by mini-css-extract-plugin
export var deliveryRow = "_px-a";
export var fixedHeight = "_px-4";
export var freightLogo = "_px-9";
export var fullWidth = "_px-3";
export var priceColumn = "_px-5";
export var radioSelected = "_px-7";
export var radioUnselected = "_px-6";
export var selectedOption = "_px-2";
export var selectedOptionContainer = "_px-1";
export var selection = "_px-0";
export var tallSkeletonText = "_px-8";